import { Field as RffField } from 'react-final-form';
import { RffFieldProps } from './FieldProps';
import * as React from 'react';

export const Field: React.FC<RffFieldProps> = ({ children, ...restProps }) => {
  return <RffField {...restProps}>{children}</RffField>;
};

export default Field;
